import { fetchGracenoteLineups, fetchWorkplaceById } from "core/API/GameMasterData";
import { fetchGracenoteChannels, fetchGracenoteTeams } from "core/API/gameMasterSports";
import Cookies from "js-cookie";
import { useQuery } from "react-query";
import { GracenoteTeam, WorkplaceDetails } from "types";

export const useLineups = (workplaceId: number | undefined) => {
    return useQuery({
        queryKey: ["gracenote-lineups", workplaceId],
        queryFn: () => fetchGracenoteLineups(workplaceId as number),
        staleTime: Infinity,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: !!workplaceId,
    });
};

export const useWorkplace = () => {
    const workplaceId = localStorage.getItem("workplace-id");

    return useQuery<WorkplaceDetails>({
        queryKey: ["workplace", workplaceId],
        queryFn: () => fetchWorkplaceById(workplaceId!),
        enabled: !!workplaceId, // Only fetch if workplaceId exists
        staleTime: Infinity, // Fetch only once and cache forever
        retry: 1, // Retry once on failure
        refetchOnWindowFocus: false, // Do not refetch when window regains focus
        refetchOnReconnect: false, // Disable refetching on network reconnect
    });
};


export const useGracenoteTeams = () => {
    return useQuery<GracenoteTeam[]>({
        queryKey: ["gracenote-teams"],
        queryFn: fetchGracenoteTeams,
        staleTime: Infinity, // Data stays fresh forever
        retry: 1, // Retry once on failure
        refetchOnWindowFocus: false, // Disable refetching on window focus
    });
};



export const useChannels = (lineupID: string) => {
    return useQuery({
        queryKey: ["gracenote-channels", lineupID],
        queryFn: () => fetchGracenoteChannels(lineupID),
        staleTime: Infinity,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: !!lineupID,
    });
};